var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanjemantoFinanceiroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 9.83335V2.50002C17.4167 1.49169 16.5917 0.666687 15.5834 0.666687H2.75008C1.74175 0.666687 0.916748 1.49169 0.916748 2.50002V9.83335C0.916748 10.8417 1.74175 11.6667 2.75008 11.6667H15.5834C16.5917 11.6667 17.4167 10.8417 17.4167 9.83335ZM9.16675 8.91669C7.64508 8.91669 6.41675 7.68835 6.41675 6.16669C6.41675 4.64502 7.64508 3.41669 9.16675 3.41669C10.6884 3.41669 11.9167 4.64502 11.9167 6.16669C11.9167 7.68835 10.6884 8.91669 9.16675 8.91669ZM21.0834 3.41669V13.5C21.0834 14.5084 20.2584 15.3334 19.2501 15.3334H3.66675V13.5H19.2501V3.41669H21.0834Z",
    fill: "#7E0386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanjemantoFinanceiroIcon);
export default __webpack_public_path__ + "static/media/planjemantoFinanceiroIcon.caeb969d6bcd4d7a461d2025f58dfb7b.svg";
export { ForwardRef as ReactComponent };